<div class="TPWL-template-header-content" role="header-content">
  <div is="user_settings"></div>
  <div is="banner"></div>
  <div id="tpwl-main-form" is="mewtwo" data-handle="whitelabel"></div>
  <div class="hidden" is="search_history" id="search_history"></div>
  <div class="sticky-informer js-sticky-informer" is="sticky_informer"></div>
</div>
